export default __webpack_public_path__ + "static/media/hide.f2727e7b.png";